// 首页CID
export const HomePageCid = 'c_waimai_c_overseas_aatucy3n';
//
export const ProductCardMv = 'b_waimai_c_overseas_vb9w5duu_mv';
//
export const ProductCardMc = 'b_waimai_c_overseas_vb9w5duu_mc';
// 自提落地页CID
export const PickUpPageCid = 'c_sailor_c_m5n64ar9';

// 品质专区CID
export const QualitySpecialCid = 'c_sailor_c_deftsb3t';

// 主子包传参（暂时无用）
export const pageSource = {
  HomePageFeeds: 'HomePageFeeds', //首页Feed
  PickUpHomePage: 'HomePage', //自提落地页-未使用
  QualitySpecialPage: 'QualitySpecial' //品质专区落地页
};

export const ShopFavoritesCID = 'c_waimai_c_overseas_uvyhshpd';

/**
 * 业务类型
 */
export const bizType = {
  homePageBusinessType: 'homePage',
  pickUpBusinessType: 'pickUpPage',
  qualitySpecialType: 'qualitySpecialPage',
  ShopFavorites: 'shopFavorites'
};

/**
 * 配送类型
 */
export const pickType = {
  deliveryType: 'delivery',
  pickupType: 'pickup',
};

/**
 * 主包BundleName
 */
export const MainPageBundleNameList = {
  PickUp: 'mach_pro_sailor_c_pick_up_page_main', //自提落地页
  Home: 'mach_pro_sailor_c_home_page_main', //首页
  QualitySpecial: 'mach_pro_sailor_c_quality_special_page_main', //品质专区落地页
  ShopFavorites: 'mach_pro_sailor_c_shop_favorites' // 收藏页
};
